// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WellnessPlan-module__font-s-10___H5Rlw {
  font-size: 10px !important;
}

.WellnessPlan-module__font-s-12___ka_Uo {
  font-size: 12px !important;
}

.WellnessPlan-module__font-s-13___RXU9e {
  font-size: 13px !important;
}

.WellnessPlan-module__font-s-14___XMSPP {
  font-size: 14px !important;
}

.WellnessPlan-module__font-s-15___L48qZ {
  font-size: 15px !important;
}

.WellnessPlan-module__font-s-16___ftyPe {
  font-size: 16px !important;
}

.WellnessPlan-module__font-s-18___u01jR {
  font-size: 18px !important;
}

.WellnessPlan-module__font-s-20___Cmcbz {
  font-size: 20px !important;
}

.WellnessPlan-module__font-s-22___qwdSv {
  font-size: 22px !important;
}

.WellnessPlan-module__font-s-28___tLG_S {
  font-size: 28px !important;
}

.WellnessPlan-module__font-w-400___s8jYL {
  font-weight: 400 !important;
}

.WellnessPlan-module__font-w-500___XIROa {
  font-weight: 500 !important;
}

.WellnessPlan-module__font-w-600___GBUYE {
  font-weight: 600 !important;
}

.WellnessPlan-module__font-w-700___OAgbf {
  font-weight: 700 !important;
}

.WellnessPlan-module__p-5___Ovr7e {
  padding: 5px !important;
}

.WellnessPlan-module__p-12___yeMmn {
  padding: 12px !important;
}

.WellnessPlan-module__p-16___TsX0A {
  padding: 16px !important;
}

.WellnessPlan-module__p-30___LuxR4 {
  padding: 30px !important;
}

.WellnessPlan-module__p-b-0___kOUqA {
  padding-bottom: 0 !important;
}

.WellnessPlan-module__p-b-5___wBZuW {
  padding-bottom: 5px !important;
}

.WellnessPlan-module__p-b-10___C0ELB {
  padding-bottom: 10px !important;
}

.WellnessPlan-module__p-b-12___yg93a {
  padding-bottom: 12px !important;
}

.WellnessPlan-module__p-b-16___g7HCG {
  padding-bottom: 16px !important;
}

.WellnessPlan-module__p-b-18___tNSLv {
  padding-bottom: 18px !important;
}

.WellnessPlan-module__p-b-20___BjVUl {
  padding-bottom: 20px !important;
}

.WellnessPlan-module__p-b-25___aZtfR {
  padding-bottom: 25px !important;
}

.WellnessPlan-module__p-b-30___As3ia {
  padding-bottom: 30px !important;
}

.WellnessPlan-module__p-b-50___DG3S9 {
  padding-bottom: 50px !important;
}

.WellnessPlan-module__p-t-0___CT_FG {
  padding-top: 0 !important;
}

.WellnessPlan-module__p-t-12___EGHVQ {
  padding-top: 12px !important;
}

.WellnessPlan-module__p-t-16___Hgi7N {
  padding-top: 16px !important;
}

.WellnessPlan-module__p-t-18___lMzbK {
  padding-top: 18px !important;
}

.WellnessPlan-module__p-t-20___RACz8 {
  padding-top: 20px !important;
}

.WellnessPlan-module__p-t-30____G1BZ {
  padding-top: 30px !important;
}

.WellnessPlan-module__p-t-40___QkM5o {
  padding-top: 40px !important;
}

.WellnessPlan-module__p-t-50___rcI2n {
  padding-top: 50px !important;
}

.WellnessPlan-module__p-l-20___NF61T {
  padding-left: 20px !important;
}

.WellnessPlan-module__p-l-30___ObszB {
  padding-left: 30px !important;
}

.WellnessPlan-module__p-l-40___AXJzR {
  padding-left: 40px !important;
}

.WellnessPlan-module__p-r-16___QkZI9 {
  padding-right: 16px !important;
}

.WellnessPlan-module__p-r-20___bZih7 {
  padding-right: 20px !important;
}

.WellnessPlan-module__p-r-30___F0gim {
  padding-right: 30px !important;
}

.WellnessPlan-module__p-r-50___XAIVd {
  padding-right: 50px !important;
}

.WellnessPlan-module__p-r-60___wKghg {
  padding-right: 60px !important;
}

.WellnessPlan-module__m-b-1___DbjN2 {
  margin-bottom: 1px !important;
}

.WellnessPlan-module__m-b-2___pTYRP {
  margin-bottom: 2px !important;
}

.WellnessPlan-module__m-b-6___Pymak {
  margin-bottom: 6px !important;
}

.WellnessPlan-module__m-b-8___iWZwl {
  margin-bottom: 8px !important;
}

.WellnessPlan-module__m-b-10___SNNmH {
  margin-bottom: 10px !important;
}

.WellnessPlan-module__m-b-14___GWp44 {
  margin-bottom: 14px !important;
}

.WellnessPlan-module__m-b-16___ll4RD {
  margin-bottom: 16px !important;
}

.WellnessPlan-module__m-b-20___CciFC {
  margin-bottom: 20px !important;
}

.WellnessPlan-module__m-b-22___raE5r {
  margin-bottom: 22px !important;
}

.WellnessPlan-module__m-b-24___krMDJ {
  margin-bottom: 24px !important;
}

.WellnessPlan-module__m-b-30___ntrvm {
  margin-bottom: 30px !important;
}

.WellnessPlan-module__m-b-32____xnfo {
  margin-bottom: 32px !important;
}

.WellnessPlan-module__m-b-40___SN_OG {
  margin-bottom: 40px !important;
}

.WellnessPlan-module__m-t-2___m9220 {
  margin-top: 2px !important;
}

.WellnessPlan-module__m-t-3___JqXpJ {
  margin-top: 3px !important;
}

.WellnessPlan-module__m-t-4___JBLKo {
  margin-top: 4px !important;
}

.WellnessPlan-module__m-t-5___AVWER {
  margin-top: 5px !important;
}

.WellnessPlan-module__m-t-8____NxUg {
  margin-top: 8px !important;
}

.WellnessPlan-module__m-t-10___q2tH0 {
  margin-top: 10px !important;
}

.WellnessPlan-module__m-t-15___eRDW2 {
  margin-top: 15px !important;
}

.WellnessPlan-module__m-t-16___qnlu6 {
  margin-top: 16px !important;
}

.WellnessPlan-module__m-t-20___fPcU_ {
  margin-top: 20px !important;
}

.WellnessPlan-module__m-t-22___YVUR0 {
  margin-top: 22px !important;
}

.WellnessPlan-module__m-t-30___tdYSC {
  margin-top: 30px !important;
}

.WellnessPlan-module__m-t-32___rl3BD {
  margin-top: 32px !important;
}

.WellnessPlan-module__m-l-auto___TbArj {
  margin-left: auto !important;
}

.WellnessPlan-module__m-l-4___iiTEo {
  margin-left: 4px !important;
}

.WellnessPlan-module__m-l-5___PHzpe {
  margin-left: 5px !important;
}

.WellnessPlan-module__m-l-6___lhmLV {
  margin-left: 6px !important;
}

.WellnessPlan-module__m-l-8___CH9hv {
  margin-left: 8px !important;
}

.WellnessPlan-module__m-l-10___1oBfK {
  margin-left: 10px !important;
}

.WellnessPlan-module__m-l-16___mtqQ0 {
  margin-left: 16px !important;
}

.WellnessPlan-module__m-l-20___RGW7Q {
  margin-left: 20px !important;
}

.WellnessPlan-module__m-l-24___CyfPM {
  margin-left: 24px !important;
}

.WellnessPlan-module__m-l-30___jOw94 {
  margin-left: 30px !important;
}

.WellnessPlan-module__m-l-35___mk2gF {
  margin-left: 35px !important;
}

.WellnessPlan-module__m-l-40___svvuL {
  margin-left: 40px !important;
}

.WellnessPlan-module__m-r-8___cnVwz {
  margin-right: 8px !important;
}

.WellnessPlan-module__m-r-10___QmKjq {
  margin-right: 10px !important;
}

.WellnessPlan-module__m-r-16___uo5Mm {
  margin-right: 16px !important;
}

.WellnessPlan-module__m-r-20___mdBN7 {
  margin-right: 20px !important;
}

.WellnessPlan-module__m-r-24___jycSj {
  margin-right: 24px !important;
}

.WellnessPlan-module__m-r-30___Sodbs {
  margin-right: 30px !important;
}

.WellnessPlan-module__m-r-40___FDFt7 {
  margin-right: 40px !important;
}

.WellnessPlan-module__border-r-3___Dl4ov {
  border-radius: 3px !important;
}

.WellnessPlan-module__border-r-4___EXHlX {
  border-radius: 4px !important;
}

.WellnessPlan-module__border-r-6___U1RAm {
  border-radius: 6px !important;
}

.WellnessPlan-module__border-r-10___CaCqz {
  border-radius: 10px !important;
}

.WellnessPlan-module__border-r-12___QwNY9 {
  border-radius: 12px !important;
}

.WellnessPlan-module__border-r-16___Ca9Ey {
  border-radius: 16px !important;
}

.WellnessPlan-module__border-r-50___dgENO {
  border-radius: 50% !important;
}

.WellnessPlan-module__primary-border___Zt0J3 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.WellnessPlan-module__primary-border-b___Yxfzp {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.WellnessPlan-module__primary-border-t___NoSjT {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.WellnessPlan-module__primary-border-l___pKtuF {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.WellnessPlan-module__primary-border-r___uZzif {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.WellnessPlan-module__secondary-border___jkxq8 {
  border: 1px solid #637768;
}

.WellnessPlan-module__secondary-border-b___OflNj {
  border-bottom: 1px solid #637768;
}

.WellnessPlan-module__secondary-border-t___LjjFE {
  border-top: 1px solid #637768;
}

.WellnessPlan-module__secondary-border-l___eUa6Z {
  border-left: 1px solid #637768;
}

.WellnessPlan-module__secondary-border-r___lOVQV {
  border-right: 1px solid #637768;
}

.WellnessPlan-module__gap-0___qEJBI {
  gap: 0 !important;
}

.WellnessPlan-module__gap-2___lcOQa {
  gap: 2px !important;
}

.WellnessPlan-module__gap-4___xiKO8 {
  gap: 4px !important;
}

.WellnessPlan-module__gap-5___vThov {
  gap: 5px !important;
}

.WellnessPlan-module__gap-6___K_Gct {
  gap: 6px !important;
}

.WellnessPlan-module__gap-8___LJcIk {
  gap: 8px !important;
}

.WellnessPlan-module__gap-10___s3XL2 {
  gap: 10px !important;
}

.WellnessPlan-module__gap-12___ekjyX {
  gap: 12px !important;
}

.WellnessPlan-module__gap-14___VaAqv {
  gap: 14px !important;
}

.WellnessPlan-module__gap-16___PQz48 {
  gap: 16px !important;
}

.WellnessPlan-module__gap-18___EU2eB {
  gap: 18px !important;
}

.WellnessPlan-module__gap-20___iepwY {
  gap: 20px !important;
}

.WellnessPlan-module__gap-24___dE3OG {
  gap: 24px !important;
}

.WellnessPlan-module__gap-26___DwssI {
  gap: 26px !important;
}

.WellnessPlan-module__gap-30___DtO6c {
  gap: 30px !important;
}

.WellnessPlan-module__gap-32___qMgyV {
  gap: 32px !important;
}

.WellnessPlan-module__gap-40___ap0lB {
  gap: 40px !important;
}

.WellnessPlan-module__gap-50___eWGNb {
  gap: 50px !important;
}

.WellnessPlan-module__flex-1___dyDTw {
  flex: 1;
}

.WellnessPlan-module__flex-none___Vzjq1 {
  flex: none !important;
}

.WellnessPlan-module__flex-column___XkaF_ {
  display: flex;
  flex-direction: column !important;
}

.WellnessPlan-module__flex-row___vgdvC {
  display: flex;
  flex-direction: row !important;
}

.WellnessPlan-module__vertically-centered___mx90w {
  display: flex;
  align-items: center !important;
}

.WellnessPlan-module__horizontally-centered___DmKve {
  display: flex;
  justify-content: center !important;
}

.WellnessPlan-module__horizontally-end___OUB2X {
  display: flex;
  justify-content: end !important;
}

.WellnessPlan-module__vertically-start___enjEJ {
  display: flex;
  align-items: start !important;
}

.WellnessPlan-module__space-between___pcWu0 {
  display: flex;
  justify-content: space-between !important;
}

.WellnessPlan-module__flex-wrap___v7ZBJ {
  flex-wrap: wrap !important;
}

.WellnessPlan-module__height-100___T2aes {
  height: 100%;
}

.WellnessPlan-module__width-50___MTz7g {
  width: 50% !important;
}

.WellnessPlan-module__width-100___yULxi {
  width: 100%;
}

.WellnessPlan-module__cursor-pointer___miP_5 {
  cursor: pointer;
}

.WellnessPlan-module__cursor-not-allowed___SE4DP {
  cursor: not-allowed !important;
}

.WellnessPlan-module__absolute-centered___GzL8U {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.WellnessPlan-module__absolute___pCl29 {
  position: absolute;
}

.WellnessPlan-module__relative___Fx_1M {
  position: relative;
}

.WellnessPlan-module__fixed___cBBlC {
  position: fixed;
}

.WellnessPlan-module__visible___LIbDD {
  opacity: 1;
}

.WellnessPlan-module__invisible___SL8ng {
  opacity: 0;
}

.WellnessPlan-module__col-90___uecXO {
  width: 90% !important;
}

.WellnessPlan-module__col-auto___Jdy5f {
  width: auto !important;
}

.WellnessPlan-module__medical-tabs___puryc {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.WellnessPlan-module__medical-table-new___oa6DQ {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.WellnessPlan-module__medical-table-new___oa6DQ:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.WellnessPlan-module__medical-table-new___oa6DQ::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.WellnessPlan-module__medical-table-new___oa6DQ::-webkit-scrollbar-track {
  display: none;
}
.WellnessPlan-module__medical-table-new___oa6DQ.WellnessPlan-module__no-pagination___abNWM {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.WellnessPlan-module__medical-table-new___oa6DQ.WellnessPlan-module__no-pagination___abNWM:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.WellnessPlan-module__medical-table-new___oa6DQ.WellnessPlan-module__no-pagination___abNWM::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.WellnessPlan-module__medical-table-new___oa6DQ.WellnessPlan-module__no-pagination___abNWM::-webkit-scrollbar-track {
  display: none;
}

.WellnessPlan-module__medical-table-empty___sDLYF {
  padding: 14px 40px !important;
}

.WellnessPlan-module__icon-btn___BLQaB {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.WellnessPlan-module__search-icon___rKKzY {
  width: 24px;
  height: 24px;
  align-self: center;
}

.WellnessPlan-module__disable-select___HVDny {
  user-select: none;
}

.WellnessPlan-module__break-word___tjvDF {
  word-break: break-word;
}

.WellnessPlan-module__popup-clear-btn___yTNH_ {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.WellnessPlan-module__scroll-m-b-20___a83Ng {
  scroll-margin-bottom: 20px;
}

.WellnessPlan-module__wrapper___lx0fD {
  margin: 36px 48px 36px 16px;
}
.WellnessPlan-module__wrapper___lx0fD .WellnessPlan-module__header___LijTo {
  background-color: #fdfcfa;
  padding: 12px 16px;
}
.WellnessPlan-module__wrapper___lx0fD .WellnessPlan-module__header___LijTo.WellnessPlan-module__isExtended___OYtuK {
  border-radius: 12px 12px 0 0 !important;
}
.WellnessPlan-module__wrapper___lx0fD .WellnessPlan-module__header___LijTo .WellnessPlan-module__title___kMbbO {
  color: #375844;
}
.WellnessPlan-module__wrapper___lx0fD .WellnessPlan-module__header___LijTo .WellnessPlan-module__subTitle___B1kbj {
  color: #637768;
}
.WellnessPlan-module__wrapper___lx0fD .WellnessPlan-module__header___LijTo .WellnessPlan-module__arrow___OWyTG {
  transform: rotate(-90deg);
  transition: transform 0.4s ease;
}
.WellnessPlan-module__wrapper___lx0fD .WellnessPlan-module__header___LijTo .WellnessPlan-module__arrow___OWyTG.WellnessPlan-module__rotate___kRtX2 {
  transform: rotate(0deg);
}
.WellnessPlan-module__wrapper___lx0fD .WellnessPlan-module__content___kYcFe {
  border-radius: 0 0 12px 12px;
  padding: 33px 42px;
  border-top: 0;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/SmartGoals/WellnessPlan/WellnessPlan.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,2BAAA;AA8pBF;AA5pBE;EACE,yBAAA;EACA,kBAAA;AA8pBJ;AA5pBI;EACE,uCAAA;AA8pBN;AA3pBI;EACE,cAAA;AA6pBN;AA1pBI;EACE,cAAA;AA4pBN;AAzpBI;EACE,yBAAA;EACA,+BAAA;AA2pBN;AAzpBM;EACE,uBAAA;AA2pBR;AAtpBE;EACE,4BAAA;EACA,kBAAA;EACA,aAAA;AAwpBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.wrapper {\n  margin: 36px 48px 36px 16px;\n\n  .header {\n    background-color: get-color(grayNew, ultra-light);\n    padding: 12px 16px;\n\n    &.isExtended {\n      border-radius: 12px 12px 0 0 !important;\n    }\n\n    .title {\n      color: get-color(greenNew, dark);\n    }\n\n    .subTitle {\n      color: get-color(greenNew, medium-dark);\n    }\n\n    .arrow {\n      transform: rotate(-90deg);\n      transition: transform 0.4s ease;\n\n      &.rotate {\n        transform: rotate(0deg);\n      }\n    }\n  }\n\n  .content {\n    border-radius: 0 0 12px 12px;\n    padding: 33px 42px;\n    border-top: 0;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `WellnessPlan-module__font-s-10___H5Rlw`,
	"fontS12": `WellnessPlan-module__font-s-12___ka_Uo`,
	"fontS13": `WellnessPlan-module__font-s-13___RXU9e`,
	"fontS14": `WellnessPlan-module__font-s-14___XMSPP`,
	"fontS15": `WellnessPlan-module__font-s-15___L48qZ`,
	"fontS16": `WellnessPlan-module__font-s-16___ftyPe`,
	"fontS18": `WellnessPlan-module__font-s-18___u01jR`,
	"fontS20": `WellnessPlan-module__font-s-20___Cmcbz`,
	"fontS22": `WellnessPlan-module__font-s-22___qwdSv`,
	"fontS28": `WellnessPlan-module__font-s-28___tLG_S`,
	"fontW400": `WellnessPlan-module__font-w-400___s8jYL`,
	"fontW500": `WellnessPlan-module__font-w-500___XIROa`,
	"fontW600": `WellnessPlan-module__font-w-600___GBUYE`,
	"fontW700": `WellnessPlan-module__font-w-700___OAgbf`,
	"p5": `WellnessPlan-module__p-5___Ovr7e`,
	"p12": `WellnessPlan-module__p-12___yeMmn`,
	"p16": `WellnessPlan-module__p-16___TsX0A`,
	"p30": `WellnessPlan-module__p-30___LuxR4`,
	"pB0": `WellnessPlan-module__p-b-0___kOUqA`,
	"pB5": `WellnessPlan-module__p-b-5___wBZuW`,
	"pB10": `WellnessPlan-module__p-b-10___C0ELB`,
	"pB12": `WellnessPlan-module__p-b-12___yg93a`,
	"pB16": `WellnessPlan-module__p-b-16___g7HCG`,
	"pB18": `WellnessPlan-module__p-b-18___tNSLv`,
	"pB20": `WellnessPlan-module__p-b-20___BjVUl`,
	"pB25": `WellnessPlan-module__p-b-25___aZtfR`,
	"pB30": `WellnessPlan-module__p-b-30___As3ia`,
	"pB50": `WellnessPlan-module__p-b-50___DG3S9`,
	"pT0": `WellnessPlan-module__p-t-0___CT_FG`,
	"pT12": `WellnessPlan-module__p-t-12___EGHVQ`,
	"pT16": `WellnessPlan-module__p-t-16___Hgi7N`,
	"pT18": `WellnessPlan-module__p-t-18___lMzbK`,
	"pT20": `WellnessPlan-module__p-t-20___RACz8`,
	"pT30": `WellnessPlan-module__p-t-30____G1BZ`,
	"pT40": `WellnessPlan-module__p-t-40___QkM5o`,
	"pT50": `WellnessPlan-module__p-t-50___rcI2n`,
	"pL20": `WellnessPlan-module__p-l-20___NF61T`,
	"pL30": `WellnessPlan-module__p-l-30___ObszB`,
	"pL40": `WellnessPlan-module__p-l-40___AXJzR`,
	"pR16": `WellnessPlan-module__p-r-16___QkZI9`,
	"pR20": `WellnessPlan-module__p-r-20___bZih7`,
	"pR30": `WellnessPlan-module__p-r-30___F0gim`,
	"pR50": `WellnessPlan-module__p-r-50___XAIVd`,
	"pR60": `WellnessPlan-module__p-r-60___wKghg`,
	"mB1": `WellnessPlan-module__m-b-1___DbjN2`,
	"mB2": `WellnessPlan-module__m-b-2___pTYRP`,
	"mB6": `WellnessPlan-module__m-b-6___Pymak`,
	"mB8": `WellnessPlan-module__m-b-8___iWZwl`,
	"mB10": `WellnessPlan-module__m-b-10___SNNmH`,
	"mB14": `WellnessPlan-module__m-b-14___GWp44`,
	"mB16": `WellnessPlan-module__m-b-16___ll4RD`,
	"mB20": `WellnessPlan-module__m-b-20___CciFC`,
	"mB22": `WellnessPlan-module__m-b-22___raE5r`,
	"mB24": `WellnessPlan-module__m-b-24___krMDJ`,
	"mB30": `WellnessPlan-module__m-b-30___ntrvm`,
	"mB32": `WellnessPlan-module__m-b-32____xnfo`,
	"mB40": `WellnessPlan-module__m-b-40___SN_OG`,
	"mT2": `WellnessPlan-module__m-t-2___m9220`,
	"mT3": `WellnessPlan-module__m-t-3___JqXpJ`,
	"mT4": `WellnessPlan-module__m-t-4___JBLKo`,
	"mT5": `WellnessPlan-module__m-t-5___AVWER`,
	"mT8": `WellnessPlan-module__m-t-8____NxUg`,
	"mT10": `WellnessPlan-module__m-t-10___q2tH0`,
	"mT15": `WellnessPlan-module__m-t-15___eRDW2`,
	"mT16": `WellnessPlan-module__m-t-16___qnlu6`,
	"mT20": `WellnessPlan-module__m-t-20___fPcU_`,
	"mT22": `WellnessPlan-module__m-t-22___YVUR0`,
	"mT30": `WellnessPlan-module__m-t-30___tdYSC`,
	"mT32": `WellnessPlan-module__m-t-32___rl3BD`,
	"mLAuto": `WellnessPlan-module__m-l-auto___TbArj`,
	"mL4": `WellnessPlan-module__m-l-4___iiTEo`,
	"mL5": `WellnessPlan-module__m-l-5___PHzpe`,
	"mL6": `WellnessPlan-module__m-l-6___lhmLV`,
	"mL8": `WellnessPlan-module__m-l-8___CH9hv`,
	"mL10": `WellnessPlan-module__m-l-10___1oBfK`,
	"mL16": `WellnessPlan-module__m-l-16___mtqQ0`,
	"mL20": `WellnessPlan-module__m-l-20___RGW7Q`,
	"mL24": `WellnessPlan-module__m-l-24___CyfPM`,
	"mL30": `WellnessPlan-module__m-l-30___jOw94`,
	"mL35": `WellnessPlan-module__m-l-35___mk2gF`,
	"mL40": `WellnessPlan-module__m-l-40___svvuL`,
	"mR8": `WellnessPlan-module__m-r-8___cnVwz`,
	"mR10": `WellnessPlan-module__m-r-10___QmKjq`,
	"mR16": `WellnessPlan-module__m-r-16___uo5Mm`,
	"mR20": `WellnessPlan-module__m-r-20___mdBN7`,
	"mR24": `WellnessPlan-module__m-r-24___jycSj`,
	"mR30": `WellnessPlan-module__m-r-30___Sodbs`,
	"mR40": `WellnessPlan-module__m-r-40___FDFt7`,
	"borderR3": `WellnessPlan-module__border-r-3___Dl4ov`,
	"borderR4": `WellnessPlan-module__border-r-4___EXHlX`,
	"borderR6": `WellnessPlan-module__border-r-6___U1RAm`,
	"borderR10": `WellnessPlan-module__border-r-10___CaCqz`,
	"borderR12": `WellnessPlan-module__border-r-12___QwNY9`,
	"borderR16": `WellnessPlan-module__border-r-16___Ca9Ey`,
	"borderR50": `WellnessPlan-module__border-r-50___dgENO`,
	"primaryBorder": `WellnessPlan-module__primary-border___Zt0J3`,
	"primaryBorderB": `WellnessPlan-module__primary-border-b___Yxfzp`,
	"primaryBorderT": `WellnessPlan-module__primary-border-t___NoSjT`,
	"primaryBorderL": `WellnessPlan-module__primary-border-l___pKtuF`,
	"primaryBorderR": `WellnessPlan-module__primary-border-r___uZzif`,
	"secondaryBorder": `WellnessPlan-module__secondary-border___jkxq8`,
	"secondaryBorderB": `WellnessPlan-module__secondary-border-b___OflNj`,
	"secondaryBorderT": `WellnessPlan-module__secondary-border-t___LjjFE`,
	"secondaryBorderL": `WellnessPlan-module__secondary-border-l___eUa6Z`,
	"secondaryBorderR": `WellnessPlan-module__secondary-border-r___lOVQV`,
	"gap0": `WellnessPlan-module__gap-0___qEJBI`,
	"gap2": `WellnessPlan-module__gap-2___lcOQa`,
	"gap4": `WellnessPlan-module__gap-4___xiKO8`,
	"gap5": `WellnessPlan-module__gap-5___vThov`,
	"gap6": `WellnessPlan-module__gap-6___K_Gct`,
	"gap8": `WellnessPlan-module__gap-8___LJcIk`,
	"gap10": `WellnessPlan-module__gap-10___s3XL2`,
	"gap12": `WellnessPlan-module__gap-12___ekjyX`,
	"gap14": `WellnessPlan-module__gap-14___VaAqv`,
	"gap16": `WellnessPlan-module__gap-16___PQz48`,
	"gap18": `WellnessPlan-module__gap-18___EU2eB`,
	"gap20": `WellnessPlan-module__gap-20___iepwY`,
	"gap24": `WellnessPlan-module__gap-24___dE3OG`,
	"gap26": `WellnessPlan-module__gap-26___DwssI`,
	"gap30": `WellnessPlan-module__gap-30___DtO6c`,
	"gap32": `WellnessPlan-module__gap-32___qMgyV`,
	"gap40": `WellnessPlan-module__gap-40___ap0lB`,
	"gap50": `WellnessPlan-module__gap-50___eWGNb`,
	"flex1": `WellnessPlan-module__flex-1___dyDTw`,
	"flexNone": `WellnessPlan-module__flex-none___Vzjq1`,
	"flexColumn": `WellnessPlan-module__flex-column___XkaF_`,
	"flexRow": `WellnessPlan-module__flex-row___vgdvC`,
	"verticallyCentered": `WellnessPlan-module__vertically-centered___mx90w`,
	"horizontallyCentered": `WellnessPlan-module__horizontally-centered___DmKve`,
	"horizontallyEnd": `WellnessPlan-module__horizontally-end___OUB2X`,
	"verticallyStart": `WellnessPlan-module__vertically-start___enjEJ`,
	"spaceBetween": `WellnessPlan-module__space-between___pcWu0`,
	"flexWrap": `WellnessPlan-module__flex-wrap___v7ZBJ`,
	"height100": `WellnessPlan-module__height-100___T2aes`,
	"width50": `WellnessPlan-module__width-50___MTz7g`,
	"width100": `WellnessPlan-module__width-100___yULxi`,
	"cursorPointer": `WellnessPlan-module__cursor-pointer___miP_5`,
	"cursorNotAllowed": `WellnessPlan-module__cursor-not-allowed___SE4DP`,
	"absoluteCentered": `WellnessPlan-module__absolute-centered___GzL8U`,
	"absolute": `WellnessPlan-module__absolute___pCl29`,
	"relative": `WellnessPlan-module__relative___Fx_1M`,
	"fixed": `WellnessPlan-module__fixed___cBBlC`,
	"visible": `WellnessPlan-module__visible___LIbDD`,
	"invisible": `WellnessPlan-module__invisible___SL8ng`,
	"col90": `WellnessPlan-module__col-90___uecXO`,
	"colAuto": `WellnessPlan-module__col-auto___Jdy5f`,
	"medicalTabs": `WellnessPlan-module__medical-tabs___puryc`,
	"medicalTableNew": `WellnessPlan-module__medical-table-new___oa6DQ`,
	"noPagination": `WellnessPlan-module__no-pagination___abNWM`,
	"medicalTableEmpty": `WellnessPlan-module__medical-table-empty___sDLYF`,
	"iconBtn": `WellnessPlan-module__icon-btn___BLQaB`,
	"searchIcon": `WellnessPlan-module__search-icon___rKKzY`,
	"disableSelect": `WellnessPlan-module__disable-select___HVDny`,
	"breakWord": `WellnessPlan-module__break-word___tjvDF`,
	"popupClearBtn": `WellnessPlan-module__popup-clear-btn___yTNH_`,
	"scrollMB20": `WellnessPlan-module__scroll-m-b-20___a83Ng`,
	"wrapper": `WellnessPlan-module__wrapper___lx0fD`,
	"header": `WellnessPlan-module__header___LijTo`,
	"isExtended": `WellnessPlan-module__isExtended___OYtuK`,
	"title": `WellnessPlan-module__title___kMbbO`,
	"subTitle": `WellnessPlan-module__subTitle___B1kbj`,
	"arrow": `WellnessPlan-module__arrow___OWyTG`,
	"rotate": `WellnessPlan-module__rotate___kRtX2`,
	"content": `WellnessPlan-module__content___kYcFe`
};
module.exports = ___CSS_LOADER_EXPORT___;
